var _defs, _polygon, _polygon2, _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _polyline6, _polyline7, _polyline8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadiant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;stroke:#000;stroke-linejoin:round;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "26.93 5.35 86.78 5.26 96.57 15.01 96.57 95.25 86.3 105.26 27.86 105.09 17.07 93.9 17.07 15.36 26.93 5.35"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "23.77 22.76 34.87 14.01 78.37 14.12 89.69 22.76 89.79 87.87 78.96 96.18 34.39 96.18 23.77 87.82 23.77 22.76"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "17.07 15.36 23.77 22.76 33.37 55.26 23.77 87.82 17.07 93.9"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "27.86 105.09 34.39 96.18 35.62 87.71 33.37 55.26 35.14 22.49 34.87 14.01 26.93 5.35"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "23.77 22.76 35.14 22.49 57.29 19.81 78.37 14.12 86.78 5.26"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "96.57 15.01 89.69 22.76 77.94 22.97 57.29 19.81 34.87 14.01"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "78.37 14.12 77.94 22.97 80.78 55.26 78.15 87.98 78.96 96.18 86.3 105.26"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "96.57 95.25 89.79 87.87 80.78 55.26 89.69 22.76"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "89.79 87.87 78.18 87.65 57.18 90.39 34.39 96.18"
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "23.77 87.82 35.62 87.71 57.64 90.33 78.96 96.18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiant);
export default __webpack_public_path__ + "static/media/radiant.76e0a069301459a10555699ce1005601.svg";
export { ForwardRef as ReactComponent };